import styled from "styled-components";

export const ProductsContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 0 32px;
  margin-top: 16px;
  display: inline-flex;
  justify-content: space-around;
`;

export const Button = styled.button`
  width: 48%;
  height: 40px;
  border-radius: 8px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  color: #ffffff;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
`;

export const ButtonTabelas = styled.button`
  width: 48%;
  height: 40px;
  border-radius: 8px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  color: #2d5bff;
  background: #eaefff;
`;

export const CardsContainer = styled.div`
  width: 100%;
  padding: 0 32px;
  display: inline-flex;
  justify-content: space-around;
`;
